export default __webpack_public_path__ + "static/media/ascend-logo.bc57325d.svg";